import { useState } from "react";
import { TaxPaybleForm } from "./TaxPayableForm";
import { TaxPayableTable } from "./TaxPayableTable";

const MainTaxPayable = () => {
    const [statetaxList, settaxList] = useState();
    const [statetaxList2, settaxList2] = useState();
    const showtaxtable = () => {
        stateshowtax("TaxPayable");
    }
    const canceltaxtable = () => {
        stateshowtax("TaxPayableT");
    }
    const [showtax, stateshowtax] = useState("TaxPayableT");

    return (

        <>
            <div className="row  ">
                <div className="dash_background col-12 p-0">
                    <div className="row ">

                        <div className="col-md-12">
                            {showtax == "TaxPayableT" ? <TaxPayableTable showtaxtable={showtaxtable} canceltaxtable={canceltaxtable} settaxList={settaxList} settaxList2={settaxList2} /> : <TaxPaybleForm canceltaxtable={canceltaxtable} statetaxList2={statetaxList2} statetaxList={statetaxList} />}

                        </div>


                    </div>


                </div>
            </div>
        </>

    )
}

export default MainTaxPayable;